module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_11_22_02_on.ded559f0.svg";